module.exports = __webpack_public_path__ + "img/Vorschau_2180x840_02.5d5ad281.jpg";